import React from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { URL } from 'utilities/variables';
import AddPost from './AddPost';
import { CircularProgress } from '@mui/material';

const EditPost = () => {
  const params = useParams()
  const id = params.id
  const [state, setState] = React.useState({
    data: {},
    token: '',
    redirect: false,
  })
  state.token = useSelector(state => state.AppReducer.token);

  React.useEffect(() => {
    if (id !== null) {
      fetch(`${URL}api/blog/reply/${id}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          // 'Authorization': `Bearer ${state.token}`,
          // 'Content-Type': 'application/json',
        }
      })
        .then(async (response) => {
          const json = await response.json();
          return json;
        }).then(async (json) => {
          setState({ ...state, data: json.post, redirect: true })
        });
    }
  }, []);
  return (
    <>
      <div className="d-flex justify-content-center">
        {!state.redirect && <CircularProgress color="secondary" />}
      </div>
      {state.redirect && <AddPost edit={state.data} />}
    </>
  )
}

export default EditPost